import React from "react"
import logo from "../../assets/img/logo.svg"
import { Link, withRouter } from "react-router-dom"
import styled from "@emotion/styled"
import { shadows } from "../../library/constants/styles/shadows"
import { colors } from "../../library/constants/styles/colors"
import { devices } from "../../library/constants/styles/responsive"
import * as routes from "../../library/constants/routes"
import Button from "@material-ui/core/Button/Button"

const Container = styled.header`
  @supports (display: grid) {
    display: grid;
    grid-template-columns: 1fr minmax(min-content, 1200px) 1fr;
  }

  display: flex;
  position: relative;
  z-index: 1000;
  justify-content: center;
  box-shadow: ${shadows.layout};
  background-color: ${colors.white};
`

const Content = styled.div`
  @supports (display: grid) {
    grid-column: 2 / -2;
    width: auto;
  }

  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 15px;
  width: 1200px;

  @media ${devices.xs} {
    padding: 15px;
  }
`

const LogoLink = styled(Link)`
  display: block;
  color: ${colors.grey7};
  font-size: 36px;
  font-weight: 500;

  img {
    height: 40px;
  }
`

const Header = (props) => {
  const { isLoggedIn } = props

  const pathName = window.location.pathname

  const AuthContent = () => {
    if (isLoggedIn) {
      return null
    }

    switch (pathName) {
      // case '/':
      //   return (
      //     <>
      //       <SignIn history={props.history} />
      //       <Button
      //         component={Link}
      //         to={{ pathname: routes.SIGN_IN, state: undefined }}
      //         variant="contained"
      //         color="primary"
      //         id="mobile-sign-in"
      //       >
      //         Sign In
      //       </Button>
      //     </>
      //   )

      case "/sign-up":
        return (
          <Button
            component={Link}
            to={{ pathname: routes.SIGN_IN, state: undefined }}
            variant="contained"
            color="primary"
          >
            Sign In
          </Button>
        )

      case "/sign-in":
        return (
          <Button
            component={Link}
            to={routes.SIGN_UP}
            variant="contained"
            color="primary"
          >
            Sign Up
          </Button>
        )

      case "/reset-password":
        return (
          <Button
            component={Link}
            to={routes.SIGN_UP}
            variant="contained"
            color="primary"
          >
            Sign Up
          </Button>
        )

      case "/confirmPasswordReset":
        return (
          <Button
            component={Link}
            to={routes.SIGN_IN}
            variant="contained"
            color="primary"
          >
            Sign In
          </Button>
        )

      default:
        return (
          <div className="f aic">
            <Button
              color="primary"
              variant="outlined"
              component={Link}
              to={routes.SIGN_IN}
              className="mr8"
            >
              Sign In
            </Button>
            <Button
              color="primary"
              variant="contained"
              component={Link}
              to={routes.SIGN_UP}
            >
              Sign Up
            </Button>
          </div>
        )
    }
  }

  return (
    <Container>
      <Content>
        <LogoLink to="/">
          <img src={logo} alt="Logo" />
        </LogoLink>
        <AuthContent />
      </Content>
    </Container>
  )
}

export default withRouter(Header)
